// extracted by mini-css-extract-plugin
export default {"wrapper":"QuV2b","typeContainer":"MH1Kt","answerType":"Z4B3o","test":"M3fcq","extended":"f6eaw","quiz":"oEFrd","poll":"e_Qpz","crossword":"CejEr","tag":"Efoyt"};